import { render, staticRenderFns } from "./titleview.vue?vue&type=template&id=1bc3506f&scoped=true&"
import script from "./titleview.vue?vue&type=script&lang=js&"
export * from "./titleview.vue?vue&type=script&lang=js&"
import style0 from "./titleview.vue?vue&type=style&index=0&id=1bc3506f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3506f",
  null
  
)

export default component.exports